import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { useField } from "vee-validate";
import { useAttrs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitDatePicker',
  props: {
    name: {},
    label: {},
    required: { type: Boolean },
    horizontal: { type: [String, Boolean] },
    wrapperClass: {}
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.horizontal && 'horizontal-wrapper',
            props.wrapperClass || 'a',
        ])
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, _mergeProps({
          style: {"width":"100%"},
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          type: "date",
          format: "DD/MM/YYYY",
          placeholder: "Seleziona una data"
        }, _unref(attrs)), null, 16, ["modelValue"])
      ]),
      _: 1
    }, 8, ["error", "validateStatus"])
  ], 2))
}
}

})